import { useHistory } from 'react-router-dom';
import { useCallback } from 'react';
import routePaths, { routePatterns } from 'router/route-paths';
import { toast } from 'react-toastify';
import get from 'lodash/get';
import { useIntl } from 'react-intl';
import useLastProjectId from 'hooks/project/useLastProjectId';
import { formatGraphqlErrors } from 'utils/helpers';
import { useMutation } from '@apollo/client/react';
import { VerifyEmailDocument } from 'graphql/generated/graphql';

const useVerifyEmail = () => {
  const history = useHistory();
  const { formatMessage: __ } = useIntl();
  const { lastProjectId } = useLastProjectId();

  const [verifyEmail] = useMutation(VerifyEmailDocument, {
    refetchQueries: ['Me'],
    awaitRefetchQueries: true,
    onCompleted: (data) => {
      const verifiedEmail = get(data, 'verifyEmail.emails[0].verified', false);
      if (verifiedEmail) {
        toast.success(__({ id: 'verify_account.email_verified' }));
        if (lastProjectId) {
          history.replace(routePatterns.dashboard.stringify({ id: lastProjectId }));
        } else {
          history.replace(routePaths.default);
        }
      }
    },
    onError: (e) => {
      history.replace(routePaths.login);
      toast.error(formatGraphqlErrors(e).message);
    },
  });

  const handleVerifyEmail = useCallback(
    async (token: string) => {
      try {
        const res = await verifyEmail({ variables: { token } });
        return res;
      } catch {
        // onError has handled the error: with an onError option the mutation resolved under Apollo Client 2,
        // Apollo Client 4 rejects after calling it.
        return undefined;
      }
    },
    [verifyEmail],
  );

  return handleVerifyEmail;
};

export default useVerifyEmail;
